import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectIsCNEnv } from '../selectors';

/**
 * Detect whether both in wechat and CN env (Temporarily only enabled on CN)
 * @returns {boolean}
 */
export default function useDetectWechat() {
  const isCNEnv = useSelector(selectIsCNEnv);
  const [isWechat, setIsWechat] = useState(false);
  useEffect(() => {
    const ua = window?.navigator?.userAgent ?? '';
    const isWechatMiniProgram = /miniprogram/i.test(ua);
    const isWechatBrowser = /micromessenger/i.test(ua);
    setIsWechat(isWechatMiniProgram || isWechatBrowser);
  }, []);

  return isCNEnv && isWechat;
}
